<template>
  <div
  class="btn"
  :class="{
    active: active,
    small: small,
    wider: wider,
  }"
  v-on="$listeners"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'btn',
  props: {
    active: Boolean,
    small: Boolean,
    wider: Boolean,
  },
}
</script>

<style lang="scss">
@import '../assets/css/common.scss';

.btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 7rem;
  padding: 0 4rem;
  background: #fff;
  border: 1px solid #005078;
  border-radius: 3.5rem;
  font-size: 1.8rem;
  color: #005078;
  cursor: pointer;
  user-select: none;
  transition: .1s;
  @include SP {
    height: 11rem;
    border-radius: 5.5rem;
    font-size: 3rem;
    padding: 0 6rem;
  }
  &.active {
    background: #005078;
    border-color: #005078;
    color: #fff;
  }
  &:not(.active):hover {
    border: 1px solid #bb8d50;
    background: #bb8d50;
    color: #fff;
  }
  &:not(.active):active {
    background: #151e5f;
    color: #fff;
  }
  &.small {
    font-size: 1.6rem;
    height: 4rem;
    border-radius: 2rem;
    padding: 0 3rem;
    @include SP {
      height: 7rem;
      border-radius: 3.5rem;
      font-size: 2.6rem;
      padding: 0 4.4rem;
    }
  }
  &.wider {
    padding: 0 10rem;
    background: #005078;
    border-color: #005078;
  }
  .prepend {
    display: inline-block;
    width: 3.2rem;
    margin-right: .8rem;
  }
}
</style>
